import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/generic-styles.css';
import './styles/colour-pallets.css';
import { validateEnvOrThrow } from './utils/validateEnv';
import { firebaseConfig } from './constants/firebaseConfig';

// Validate environment variables before starting the app
try {
  validateEnvOrThrow();
} catch (error) {
  // Display error in the DOM for better user experience
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="padding: 20px; max-width: 800px; margin: 50px auto; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
        <h1 style="color: #dc3545; margin-bottom: 20px;">⚠️ Configuration Error</h1>
        <pre style="background: #f8f9fa; padding: 20px; border-radius: 8px; overflow-x: auto; white-space: pre-wrap; word-wrap: break-word;">${error.message}</pre>
      </div>
    `;
  }
  throw error;
}

// Initialize Google Analytics if measurement ID is available
if (firebaseConfig.measurementId && typeof window !== 'undefined') {
  // Load gtag.js script dynamically
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${firebaseConfig.measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag configuration once script is loaded
  script.onload = () => {
    if (window.gtag) {
      window.gtag('config', firebaseConfig.measurementId, {
        page_path: window.location.pathname + window.location.search,
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
